import { get, head } from 'lodash';

export const ifOverdraftAvailable = (details) => {
  const detail = head(details.limits);
  return get(detail, 'type') === 'overdraft' && get(detail, 'amount.value') !== 0;
};

export const getOverdraftEnabledFlag = (payload) => {
  return payload.alerts[0].enabled;
};
